export default __webpack_public_path__ + "static/media/bg-11.319061f0.jpg";